var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ymap-marker',{attrs:{"properties":{ iconContent: _vm.markerLayout },"coords":[_vm.coords[0], _vm.coords[1]],"marker-id":_vm.coords[0],"icon":_vm.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }